var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-navi-user" }, [
    _vm.viewer.id
      ? _c(
          "a",
          {
            staticClass: "global-navi-user-link",
            attrs: { href: _vm.viewer.url },
          },
          [
            _c("div", { staticClass: "global-navi-user-img" }, [
              _c(
                "div",
                { staticClass: "global-navi-img" },
                [
                  _c("image-viewer", {
                    attrs: {
                      src: _vm.viewer.imageUrl || _vm.noImage,
                      "alt-src": _vm.noImage,
                      alt: _vm.viewer.nickname + "さん",
                      "small-light-params": _vm.smallLightParams,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "global-navi-user-name" }, [
              _c("span", { staticClass: "global-navi-nickname" }, [
                _vm._v(_vm._s(_vm.viewer.nickname)),
              ]),
              _c("span", { staticClass: "global-navi-mr-mrs" }, [
                _vm._v("さん"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "global-navi-user-profile" }, [
                _vm._v("プロフィールをみる"),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.memberRank
      ? _c("div", { staticClass: "global-navi-user-member-rank-wrap" }, [
          _c(
            "a",
            {
              staticClass: "global-navi-user-member-rank-link",
              attrs: { href: _vm.userPageUrl },
            },
            [
              _c(
                "div",
                { staticClass: "global-navi-user-member-rank" },
                [
                  _c(_vm.memberRankIcon, {
                    tag: "component",
                    staticClass: "global-navi-user-member-rank-icon",
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "global-navi-user-member-rank-name" },
                    [
                      _vm._v(_vm._s(_vm.memberRankLabel) + "\n          "),
                      _vm.memberRank.isPremium
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "global-navi-user-member-rank-name-sub",
                            },
                            [
                              _vm._v(
                                "(プレミアム会員 " +
                                  _vm._s(_vm.memberRank.premiumCourse) +
                                  ")"
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "global-navi-user-member-rank-about" }, [
            _c(
              "a",
              {
                staticClass: "global-navi-user-member-rank-about-link",
                attrs: { href: _vm.shoppingProgramUrl },
              },
              [_vm._v("ランクアップ特典はこちら")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }